import { render, staticRenderFns } from "./DetailedTableFloresFrutos.vue?vue&type=template&id=748690e4&scoped=true"
import script from "./DetailedTableFloresFrutos.vue?vue&type=script&lang=js"
export * from "./DetailedTableFloresFrutos.vue?vue&type=script&lang=js"
import style0 from "./DetailedTableFloresFrutos.vue?vue&type=style&index=0&id=748690e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748690e4",
  null
  
)

export default component.exports